const SEVERITY_META = {
  green: { label: "Groen", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  yellow: { label: "Geel", className: "bg-amber-50 text-amber-800 border-amber-200" },
  red: { label: "Rood", className: "bg-rose-50 text-rose-700 border-rose-200" },
};

export default function SupplierInvoiceSeverityBadge({ severity }) {
  const meta = SEVERITY_META[String(severity || "").trim()] || {
    label: "-",
    className: "bg-slate-100 text-slate-700 border-slate-200",
  };

  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-medium ${meta.className}`}>
      {meta.label}
    </span>
  );
}
